import React, { useEffect, useState } from "react";
import { Button, InputLabel, TextField } from "@material-ui/core";
import GTLabel from "components/GTLabel";
import Container from "containers/anx1/SharedModule/DropdownTreeContainer";
import CustomSelect from "../Utility/CustomSelect";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedGstin, getGstinList } from "../Notice/action";
import SingleSelect from "components/Select/SingleSelect";
import "../style.css";
import { addEmailMasterData, getEmailMasterData } from "./action";
const HeaderBar = () => {
  const [selectedEntity, setSelectedEntity] = useState("");
  const [email, setEmail] = useState("");

  const { gstinList, selectedGstin } = useSelector(
    (state) => state.noticeReducer
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGstinList());
  }, []);

  const handleGstin = (currentNode, selectedNodes) => {
    const selectedGstinValue =
      selectedNodes.length > 0
        ? selectedNodes[0]?.value || selectedNodes[0]?.label
        : "";
    dispatch(setSelectedGstin(selectedGstinValue));
    console.log("Selected GSTIN:", selectedGstinValue);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isFormValid = () => {
    return selectedGstin && selectedGstin !== "" && email && isValidEmail(email);
  };

  const handleAdd = async () => {
    if (!isFormValid()) {
      console.log("Form is not valid. GSTIN:", selectedGstin, "Email:", email);
      return;
    }
    await dispatch(addEmailMasterData(selectedGstin, email));
    dispatch(getEmailMasterData());
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent:'flex-start'
        // alignItems: "anchor-center",
        // gap: "20px",
      }}
    >
      {/* Select GSTIN */}
      <div style={{ width: "20%",zIndex:'100' }} className="dropdown-container-notice">
        <GTLabel
          title={"Select GSTIN *"}
          style={{
            fontFamily: "GT-Walsheim-medium",
            fontSize: "12px",
          }}
        />
        <Container
          mode="simpleSelect"
          data={gstinList?.map((gstin) => ({
            label: gstin,
            value: gstin,
            checked: false,
          }))}
          onChange={handleGstin}
          isDisabled={gstinList?.length === 0}
          searchable={true}
        />
      </div>

      {/* Email Input */}
      <div>
        <InputLabel
          style={{
            fontFamily: "GT-Walsheim-medium",
            fontSize: "12px",
            color: "black",
            marginBottom: "10px",
          }}
        >
          Email *
        </InputLabel>
        <TextField
          type="email"
          placeholder="Enter email address"
          value={email}
            inputProps={{ maxLength: 150 }}
          onChange={handleEmailChange}
          variant="outlined"
          size="small"
          error={email && !isValidEmail(email)}
          helperText={email && !isValidEmail(email) ? "Please enter a valid email address" : ""}
          style={{
            minWidth: "250px",
            backgroundColor: "white",
            marginTop: "4px",
            marginLeft:'1em'
          }}
        />
      </div>

      {/* Add Button */}
      <div style={{ marginTop: "26px",marginLeft:'1em' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleAdd}
          disabled={!isFormValid()}
          style={{
            backgroundColor: isFormValid() ? "#4f2d7f" : "#ccc",
            color: "white",
            fontSize: "12px",
            marginRight: "10px",
            textTransform: "capitalize",
            cursor: isFormValid() ? "pointer" : "not-allowed",
          }}
        >
          Add
        </Button>
      </div>
    </div>
  );
};

export default HeaderBar;
